import { useTranslation } from 'react-i18next';

import { cardSurface } from '@/components/atoms/Card';
import { TextLink } from '@/components/atoms/TextLink';

import styles from './FeatureUnavailable.module.scss';

interface FeatureUnavailableProps {
    linkTo: string;
    /** `unresolved` when PostHog never answered, so the copy must not say the account was refused. */
    reason: 'disabled' | 'unresolved';
}

/**
 * Shown in place of a flag-guarded page the user cannot open, or whose flag PostHog never
 * answered. It stays on the same URL, so the page can still take its place if the flag turns on
 * later in the session.
 */
export function FeatureUnavailable({ linkTo, reason }: FeatureUnavailableProps) {
    const { t } = useTranslation();
    const messageKey =
        reason === 'unresolved' ? 'featureFlag.unresolved' : 'featureFlag.unavailable';

    return (
        <section {...cardSurface({ padding: 'none' }, styles.container)} role="status">
            <p className={styles.message}>{t(messageKey)}</p>
            <TextLink to={linkTo} className={styles.link}>
                {t('featureFlag.backToLocation')}
            </TextLink>
        </section>
    );
}
